import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EntityConfig } from '../_appCommon/base/EntityConfig';
import { UrlQueryDef } from 'src/app-client/_appCommon/base/UrlQueryDef';
import { EntityDataServiceBase } from '../_appCommon/base/EntityDataServiceBase';

@Injectable({
  providedIn: 'root'
})
export class OrderDataService extends EntityDataServiceBase
{
  public createOrder_WebApiMethod: string = "";
  public getOrderDetailListByCustomerId_WebApiMethod: string = "customer";

  constructor(public http: HttpClient)
  {
    super(http, "order");
  }

  protected loadEntityConfig(): void
  {
    this.entityConfig = new EntityConfig();
    this.entityConfig.entityName = "order";
    this.entityConfig.apiUrl = "api/order";
  }

  public createOrder(body: any): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable: Observable<any> = this.http.post(this.createUrl(this.createOrder_WebApiMethod), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public getOrderDetailListByCustomerId(customerId: number): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable: Observable<any> = this.http.get(this.createUrl(this.getOrderDetailListByCustomerId_WebApiMethod + "/" + customerId), queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public getAllOrders():Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable: Observable<any> = this.http.get(this.createUrl(this.createOrder_WebApiMethod + "getTotal"), queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public updateStatus(body: any): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable : Observable<any>  = this.http.put(this.createUrl("updateStatus"), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public updateOrderPaymentType(body: any): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable : Observable<any>  = this.http.put(this.createUrl("updatePaymentType"), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public updatePaymentStatus(body: any): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable = this.http.put(this.createUrl("updatePaymentStatus"), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public getAssignedOrdersWithPendingPayment(queryDef:UrlQueryDef): Observable<any>{
      let observable = this.http.get(this.createUrl('AssignedOrdersWithPendingPayment'), queryDef.getRequestConfig()).pipe(share());
      return observable;
  }
}
